import React from 'react';

const cs4AssistantConversation = (
  <div className="space-y-4">
    {/* 1 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Welcome! Let's begin selecting your three-course meal. For the starter, do you prefer a soup, salad, or something else?
        </div>
      </div>
    </div>
    {/* 2 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          I found the assistant's query for my starter preference to be a natural and straightforward start to the meal selection process. Since it clearly laid out the broad options available, I felt comfortable sticking with my initial inclination without needing to change my mind.
        </div>
      </div>
    </div>
    {/* 3 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Great! Let's move on to your choice for a starter. Do you prefer a soup, salad, or something else? Once you choose, let me know if you’d like some nutritional feedback on your selection.
        </div>
      </div>
    </div>
    {/* 4 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The assistant's query about providing nutritional feedback was expected and appreciated. I'm comfortable with my initial choice and don't feel the need to change it.
        </div>
      </div>
    </div>
    {/* 5 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Great! Let's now move on to the main course. Do you have a preference for meat, fish, a vegetarian option, or something else? Once you make your choice, let me know if you’d like any nutritional feedback.
        </div>
      </div>
    </div>
    {/* 6 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          The assistant's prompt for choosing a main course aligns seamlessly with the meal selection process I'm used to. There is no need to reconsider my choice of the main course; I’m confident in my selection.
        </div>
      </div>
    </div>
    {/* 7 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          We're now at the final step of your meal selection. For dessert, here are your choices: Chocolate Lava Cake, Fruit Salad, Cheesecake. Please make your choice, and let me know if you would like feedback on it.
        </div>
      </div>
    </div>
    {/* 8 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          I decided to request feedback for my dessert choice as I'm feeling a little indecisive. The feedback highlighted the cheesecake's creamy texture and sweet flavor, which aligns well with my taste. This encouraged me to switch from my original thought of a Fruit Salad to the Cheesecake.
        </div>
      </div>
    </div>
    {/* 9 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          It looks like you've finalized your three-course meal selection! To recap, you've chosen a Shrimp Cocktail for your starter, Grilled Salmon as your main course, and a Cheesecake for dessert. Enjoy your meal!
        </div>
      </div>
    </div>
    {/* Interview Summary */}
    <div className="flex justify-end">
      <div className="bg-yellow-100 text-yellow-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject Interview Summary:</span>
        <div>
          Subject 1 appreciated structured, clear feedback and valued having control over when to receive it. She preferred solicited nutritional advice and highlighted the importance of neutrality, timing, and personalization. Subject 1 emphasized that unsolicited feedback could be intrusive, advocating for clear user control and autonomy during interactions with conversational agents.
        </div>
      </div>
    </div>
  </div>
);

export default cs4AssistantConversation;